import {useNavigate} from 'react-router-dom';

import {Button} from '@mantine/core';
import {useToggle} from '@mantine/hooks';


import {
    AiOutlineCloseCircle,
    AiOutlineEdit,
    AiOutlineProfile
} from 'react-icons/ai';
import {IconContext} from 'react-icons';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../../config/rbac/actions.ts";

export const useEditPageTools = () => {

        const navigate = useNavigate();

        const {allowedActions} = useVerifiedPermissions()

        const [mode, toggle] = useToggle(['view', 'edit']);

        const tools = [];


        if (allowedActions.includes(rbacActions.UpdateAccountApplication)) {

            if (mode === 'edit') {
                tools.push(<Button radius='xs' size='md' variant={'filled'} key={'profile'}
                                   leftSection={<IconContext.Provider value={{size: '24px'}}>
                                       <AiOutlineProfile/></IconContext.Provider>}
                                   onClick={() => toggle()}>Profile</Button>);
            } else {
                tools.push(<Button leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'}
                                   onClick={() => toggle()}>Edit</Button>);
            }

        }

        tools.push(<Button leftSection={<AiOutlineCloseCircle/>} variant={'outline'} key={'close'}
                           onClick={() => navigate(`/account-applications`)}>Close</Button>);


        return {
            mode,
            tools,
        };

    }
;
